const products = [
  {
    id: "erp",
    title: "ERP",
    icon: "erp",
    description:
      "Unified finance, HR, procurement and operations on a single platform for end-to-end control.",
  },
  {
    id: "crm",
    title: "CRM",
    icon: "crm",
    description:
      "Pipeline, leads, activities and a 360-degree customer view that strengthens every relationship.",
  },
  {
    id: "inventory",
    title: "Inventory",
    icon: "inventory",
    description:
      "Stock, SKUs, batches, barcodes, re-order rules, purchases and transfers — fully managed.",
  },
  {
    id: "project-management",
    title: "Project Management",
    icon: "project",
    description:
      "Tasks, sprints, Gantt, timesheets, budgets, docs and seamless team collaboration.",
  },
  {
    id: "system-design",
    title: "System Design",
    icon: "system",
    description:
      "Scalable, secure architectures — APIs, microservices, cloud and DevOps built to grow.",
  },
];

export default products;
